import { render } from "react-dom";
import { useEffect, useRef, useState } from "react";
import { useWindowScroll, useWindowSize } from "react-use";
import classNames from "classnames";

const BlockQuote = ({ content, author }) => {
  const blockquoteRef = useRef<HTMLDivElement>(null!);
  const [isActive, setIsActive] = useState<boolean>(false);
  const [isAlmostActive, setAlmostIsActive] = useState<boolean>(false);
  const { y } = useWindowScroll();
  const { height } = useWindowSize();

  useEffect(() => {
    const blockquoteTop = blockquoteRef?.current?.getClientRects()[0]?.top;
    !isActive && setIsActive(blockquoteTop < height / 2);
    !isAlmostActive && setAlmostIsActive(blockquoteTop < (height * 1.4) / 2);
  }, [y, height, setIsActive, blockquoteRef]);

  return (
    <div
      ref={blockquoteRef}
      className={classNames(
        isActive && "is-active",
        isAlmostActive && "is-almost-active",
        `rows-${Math.floor(content.split(" ").length / 9)}`
      )}
      onClick={() => setIsActive(!isActive)}
    >
      {content && (
        <h4>
          <span dangerouslySetInnerHTML={{ __html: content }}></span>
        </h4>
      )}
      {author && <span dangerouslySetInnerHTML={{ __html: author }}></span>}
    </div>
  );
};

export const useBlockquote = () => {
  useEffect(() => {
    const blockquotes = Array.from(document.querySelectorAll("blockquote"));

    // loop through each accordion on the page
    blockquotes.forEach((block) => {
      const props = {
        content: Array.from(block.querySelectorAll("span"))[0]?.innerHTML,
        author: Array.from(block.querySelectorAll("span"))[1]?.innerHTML,
      };

      if (props.content || props.author)
        return render(<BlockQuote {...props} />, block);
    });
  }, []);
};
